import React from 'react';
import type { Section as SectionType, SectionComponent } from '@ext-bookmark/shared/types';

interface SectionProps {
  section: SectionType;
  workspaceId: string;
  componentId: string;
  component: SectionComponent;
  layoutLocked: boolean;
  onDataChange: () => void;
  onEdit?: (section: SectionType) => void;
}

const Section: React.FC<SectionProps> = ({
  section,
  workspaceId: _workspaceId,
  componentId: _componentId,
  component: _component,
  layoutLocked: _layoutLocked,
  onDataChange: _onDataChange,
  onEdit: _onEdit,
}) => {
  return (
    <div
      className="absolute bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg p-4"
      style={{
        left: `${section.x}px`,
        top: `${section.y}px`,
        width: `${section.width}px`,
        height: `${section.height}px`,
      }}
    >
      <div className="text-sm font-medium text-gray-900 dark:text-white mb-2">
        {section.name}
      </div>
      <div className="text-xs text-gray-500 dark:text-gray-400">
        书签数量: {section.contentItems?.length || 0}
      </div>
    </div>
  );
};

export default Section;
